import { render, staticRenderFns } from "./operations.vue?vue&type=template&id=0ba0b767&scoped=true&"
import script from "./operations.vue?vue&type=script&lang=js&"
export * from "./operations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba0b767",
  null
  
)

export default component.exports